import PageHero from "@/components/common/PageHero";
import { IMAGES } from "@/data/site";
import { Mail, Linkedin } from "lucide-react";

const VALUES = [
  { title: "Excelência", text: "Procuramos elevados padrões de qualidade em todos os serviços que prestamos." },
  { title: "Integridade", text: "Atuamos com ética, transparência e responsabilidade em todas as relações profissionais." },
  { title: "Compromisso", text: "Acompanhamos cada atleta de forma próxima, promovendo a sua evolução contínua." },
  { title: "Ambição", text: "Trabalhamos diariamente para criar oportunidades e alcançar resultados sustentáveis." },
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="A Agência"
        title={<>Mais do que carreiras <br /><span className="text-[#A67C00]">Construímos percursos</span></>}
        subtitle="Somos uma agência especializada em scouting, desenvolvimento de jogadores e gestão de carreira."
        image={IMAGES.stadiumNight}
      />

      <section className="py-24 md:py-32 border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-16">
          <div className="reveal">
            <div className="section-eyebrow mb-6">Quem somos</div>
            <p className="text-neutral-300 text-base leading-relaxed mb-6">
              A AF Legacy Sports é uma agência especializada em scouting, desenvolvimento
              de jogadores e gestão de carreira. Identificamos talento, avaliamos potencial e criamos
              ligações entre atletas, clubes, academias, treinadores e parceiros.
            </p>
            <p className="text-neutral-300 text-base leading-relaxed mb-6">
              Cada jogador é acompanhado de forma individual, respeitando o seu momento, as suas
              características, os seus objetivos e o seu potencial.
            </p>
            <p className="text-neutral-400 text-base leading-relaxed">
              Acreditamos que uma carreira sólida não se constrói apenas através de contratos.
              Constrói-se através de preparação, disciplina, confiança, decisões responsáveis
              e relações profissionais duradouras.
            </p>
          </div>
          <div className="relative aspect-[4/5] overflow-hidden zoom-parent reveal">
            <img src={IMAGES.contractSigning} alt="Reunião profissional" className="absolute inset-0 w-full h-full object-cover" />
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#0F0F0F] border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-16">
          <div data-testid="mission-block" className="reveal">
            <div className="section-eyebrow mb-6">Missão</div>
            <h3 className="font-cinzel uppercase text-white text-3xl md:text-4xl tracking-tight mb-8">Desenvolver e promover</h3>
            <p className="text-neutral-300 leading-relaxed">
              Identificar, desenvolver e promover jovens talentos, proporcionando
              acompanhamento profissional e criando oportunidades que potenciem o seu
              crescimento desportivo e pessoal.
            </p>
          </div>
          <div data-testid="vision-block" className="reveal">
            <div className="section-eyebrow mb-6">Visão</div>
            <h3 className="font-cinzel uppercase text-white text-3xl md:text-4xl tracking-tight mb-8">Referência no scouting</h3>
            <p className="text-neutral-300 leading-relaxed">
              Ser reconhecida como uma referência na área do scouting e desenvolvimento
              de jogadores, estabelecendo parcerias sólidas com clubes e organizações
              desportivas em Portugal e no estrangeiro.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="section-eyebrow mb-6 reveal">Valores</div>
          <h2 className="font-cinzel uppercase text-white text-4xl md:text-5xl tracking-tight mb-16 max-w-3xl reveal">
            Os princípios que <span className="text-[#A67C00]">guiam a nossa forma de trabalhar</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
            {VALUES.map((v, i) => (
              <div key={v.title} data-testid={`value-${i}`} className="bg-[#0B0B0B] p-10 reveal">
                <div className="font-cinzel text-[#A67C00] text-4xl mb-6">0{i + 1}</div>
                <h3 className="font-cinzel uppercase text-white text-xl mb-4 tracking-wide">{v.title}</h3>
                <p className="text-neutral-400 text-sm leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
